import { sdk } from '@amf/shared/lib/graphQlClient';

export enum TournamentPlayType {
  FIVE_PLUS_ONE = 'five_plus_one',
  FOUR_PLUS_ONE = 'four_plus_one',
  THREE_PLUS_ONE = 'three_plus_one',
  SIX_PLUS_ONE = 'six_plus_one',
  SEVEN_PLUS_ONE = 'seven_plus_one',
  TEN_PLUS_ONE = 'ten_plus_one',
  OTHER = 'other',
}

export enum TournamentGroundType {
  ARTIFICIAL_GRASS = 'artificial',
  NATURAL_GRASS = 'natural',
  SAND = 'sand',
  BEACH_SAND = 'beach_sand',
  FLOORBOARDS = 'floorboards',
  OTHER = 'other',
}

export const LIMIT = 10;

export async function getTournaments(
  offset: number = 0,
  dateFrom: number | null,
  dateTo: number | null,
  category: string | null,
  region: string | null,
  query: string | null,
) {
  const { tournamentList } = await sdk.TournamentList({
    union: process.env.NEXT_PUBLIC_UNION,
    limit: LIMIT,
    offset,
    dateFrom,
    dateTo,
    category,
    region,
    query,
  });

  return tournamentList;
}
